"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'DeliveryArea',
  props: {
    markers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    area: {
      type: Number,
      default: 0
    },
    circle: {
      type: Object,
      default: null
    },
    storeLat: {
      type: [Number, String],
      default: null
    },
    storeLng: {
      type: [Number, String],
      default: null
    },
    storeName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      map: null,
      defaultCenter: {
        lat: 39.916527,
        lng: 116.397128
      },
      storeMarker: null,
      drawingManager: null,
      polygon: null,
      circleOverlay: null,
      polygonVertexMarkers: [],
      initialData: {
        markers: [],
        circle: null,
        area: 0
      }
    };
  },
  computed: {
    mapCenter: function mapCenter() {
      if (this.storeLat && this.storeLng) {
        var lat = parseFloat(this.storeLat);
        var lng = parseFloat(this.storeLng);
        if (!isNaN(lat) && !isNaN(lng)) {
          return {
            lat: lat,
            lng: lng
          };
        }
      }
      if (this.circle && this.circle.center) {
        return {
          lat: parseFloat(this.circle.center.lat),
          lng: parseFloat(this.circle.center.lng)
        };
      }
      return this.defaultCenter;
    }
  },
  watch: {
    storeLat: function storeLat() {
      this.updateMapCenter();
      this.updateStoreMarker();
    },
    storeLng: function storeLng() {
      this.updateMapCenter();
      this.updateStoreMarker();
    }
  },
  methods: {
    initMap: function initMap() {
      if (!window.qq || !window.qq.maps) {
        console.error('腾讯地图库未加载完成');
        return;
      }
      var center = new window.qq.maps.LatLng(this.mapCenter.lat, this.mapCenter.lng);
      this.map = new window.qq.maps.Map(this.$refs.mapContainer, {
        center: center,
        zoom: 15,
        mapTypeId: window.qq.maps.MapTypeId.ROADMAP
      });
      this.initDrawingManager();
      this.updateStoreMarker();
      this.loadExistingData();
    },
    updateMapCenter: function updateMapCenter() {
      if (this.map) {
        var center = new window.qq.maps.LatLng(this.mapCenter.lat, this.mapCenter.lng);
        this.map.setCenter(center);
      }
    },
    updateStoreMarker: function updateStoreMarker() {
      if (!this.map || !this.storeLat || !this.storeLng) {
        return;
      }
      var lat = parseFloat(this.storeLat);
      var lng = parseFloat(this.storeLng);
      if (isNaN(lat) || isNaN(lng)) {
        return;
      }
      var position = new window.qq.maps.LatLng(lat, lng);
      if (this.storeMarker) {
        this.storeMarker.setMap(null);
      }
      this.storeMarker = new window.qq.maps.Marker({
        position: position,
        map: this.map
      });
      window.qq.maps.event.addListener(this.storeMarker, 'click', function () {
        alert('you clicked me');
      });
    },
    initDrawingManager: function initDrawingManager() {
      var _this = this;
      if (!window.qq || !window.qq.maps || !window.qq.maps.drawing) {
        console.warn('腾讯地图绘图工具未加载');
        return;
      }
      this.drawingManager = new window.qq.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
          position: window.qq.maps.ControlPosition.TOP_CENTER,
          drawingModes: [window.qq.maps.drawing.OverlayType.CIRCLE, window.qq.maps.drawing.OverlayType.POLYGON]
        },
        circleOptions: {
          fillColor: new window.qq.maps.Color(64, 158, 255, 0.3),
          strokeColor: new window.qq.maps.Color(64, 158, 255, 1),
          strokeWeight: 2,
          clickable: true,
          editable: true,
          zIndex: 1
        },
        polygonOptions: {
          fillColor: new window.qq.maps.Color(64, 158, 255, 0.3),
          strokeColor: new window.qq.maps.Color(64, 158, 255, 1),
          strokeWeight: 2,
          clickable: true,
          editable: true,
          zIndex: 1
        }
      });
      this.drawingManager.setMap(this.map);

      // 监听绘制模式变化，当切换到圆形工具时自动创建圆形
      window.qq.maps.event.addListener(this.drawingManager, 'drawingmode_changed', function () {
        var mode = _this.drawingManager.getDrawingMode();
        if (mode === window.qq.maps.drawing.OverlayType.CIRCLE) {
          // 如果已存在圆形，切换到编辑模式，不再创建新圆形
          if (_this.circleOverlay) {
            _this.drawingManager.setDrawingMode(null);
            return;
          }
          // 自动以门店位置为圆心创建圆形
          _this.createCircleAtStore();
        }
      });
      window.qq.maps.event.addListener(this.drawingManager, 'overlaycomplete', function (event) {
        if (_this.circleOverlay) {
          _this.circleOverlay.setMap(null);
        }
        if (_this.polygon) {
          _this.polygon.setMap(null);
        }
        _this.clearPolygonVertexMarkers();
        if (event.type === window.qq.maps.drawing.OverlayType.CIRCLE) {
          _this.circleOverlay = event.overlay;
          _this.handleCircleComplete(event.overlay);
        } else if (event.type === window.qq.maps.drawing.OverlayType.POLYGON) {
          _this.polygon = event.overlay;
          _this.handlePolygonComplete(event.overlay);
        }
      });
    },
    createCircleAtStore: function createCircleAtStore() {
      // 检查是否有门店位置
      if (!this.storeLat || !this.storeLng) {
        this.$message && this.$message.warning('请先选择门店位置');
        this.drawingManager.setDrawingMode(null);
        return;
      }
      var lat = parseFloat(this.storeLat);
      var lng = parseFloat(this.storeLng);
      if (isNaN(lat) || isNaN(lng)) {
        this.$message && this.$message.warning('门店位置无效');
        this.drawingManager.setDrawingMode(null);
        return;
      }

      // 清除现有图形
      if (this.circleOverlay) {
        this.circleOverlay.setMap(null);
      }
      if (this.polygon) {
        this.polygon.setMap(null);
      }
      this.clearPolygonVertexMarkers();
      var center = new window.qq.maps.LatLng(lat, lng);
      var defaultRadius = 1000; // 默认半径1000米

      // 创建圆形，以门店位置为圆心
      this.circleOverlay = new window.qq.maps.Circle({
        center: center,
        radius: defaultRadius,
        fillColor: new window.qq.maps.Color(64, 158, 255, 0.3),
        strokeColor: new window.qq.maps.Color(64, 158, 255, 1),
        strokeWeight: 2,
        editable: true,
        map: this.map
      });

      // 禁用圆心编辑，只允许调整半径
      this.disableCircleCenterEdit(this.circleOverlay);

      // 处理圆形完成
      this.handleCircleComplete(this.circleOverlay);

      // 重置绘制模式为null，防止继续绘制
      this.drawingManager.setDrawingMode(null);
    },
    disableCircleCenterEdit: function disableCircleCenterEdit(circle) {
      var _this2 = this;
      // 监听圆心变化事件，如果圆心改变则重置为门店位置
      window.qq.maps.event.addListener(circle, 'center_changed', function () {
        var currentCenter = circle.getCenter();
        var storeLat = parseFloat(_this2.storeLat);
        var storeLng = parseFloat(_this2.storeLng);

        // 允许微小的误差范围
        var tolerance = 0.0001;
        if (Math.abs(currentCenter.getLat() - storeLat) > tolerance || Math.abs(currentCenter.getLng() - storeLng) > tolerance) {
          // 重置圆心为门店位置
          var fixedCenter = new window.qq.maps.LatLng(storeLat, storeLng);
          circle.setCenter(fixedCenter);
        }
      });
    },
    handleCircleComplete: function handleCircleComplete(circle) {
      var _this3 = this;
      this.clearPolygonVertexMarkers();
      var center = circle.getCenter();
      var radius = circle.getRadius();
      var circleData = {
        center: {
          lat: center.getLat(),
          lng: center.getLng()
        },
        radius: radius
      };
      var area = Math.PI * radius * radius / 1000000;
      this.$emit('draw-data-change', {
        markers: [],
        area: area,
        circle: circleData
      });
      window.qq.maps.event.addListener(circle, 'radius_changed', function () {
        var newRadius = circle.getRadius();
        var newArea = Math.PI * newRadius * newRadius / 1000000;
        _this3.$emit('draw-data-change', {
          markers: [],
          area: newArea,
          circle: {
            center: {
              lat: center.getLat(),
              lng: center.getLng()
            },
            radius: newRadius
          }
        });
      });
      window.qq.maps.event.addListener(circle, 'center_changed', function () {
        var newCenter = circle.getCenter();
        _this3.$emit('draw-data-change', {
          markers: [],
          area: area,
          circle: {
            center: {
              lat: newCenter.getLat(),
              lng: newCenter.getLng()
            },
            radius: radius
          }
        });
      });
    },
    handlePolygonComplete: function handlePolygonComplete(polygon) {
      var _this4 = this;
      this.clearPolygonVertexMarkers();
      var path = polygon.getPath();
      var markers = [];
      var area = 0;
      for (var i = 0; i < path.getLength(); i++) {
        var point = path.getAt(i);
        markers.push({
          lat: point.getLat(),
          lng: point.getLng()
        });
        this.addVertexMarker(point, i + 1);
      }
      if (markers.length >= 3) {
        area = this.calculatePolygonArea(markers);
      }
      this.$emit('draw-data-change', {
        markers: markers,
        area: area,
        circle: null
      });
      window.qq.maps.event.addListener(polygon.getPath(), 'insert_at', function () {
        _this4.updatePolygonData(polygon);
      });
      window.qq.maps.event.addListener(polygon.getPath(), 'remove_at', function () {
        _this4.updatePolygonData(polygon);
      });
      window.qq.maps.event.addListener(polygon.getPath(), 'set_at', function () {
        _this4.updatePolygonData(polygon);
      });

      // 监听多边形编辑完成事件（拖动顶点）
      window.qq.maps.event.addListener(polygon, 'mouseup', function () {
        _this4.updatePolygonData(polygon);
      });

      // 监听多边形路径变化
      window.qq.maps.event.addListener(polygon, 'path_changed', function () {
        _this4.updatePolygonData(polygon);
      });
    },
    addVertexMarker: function addVertexMarker(position, index) {
      var marker = new window.qq.maps.Marker({
        position: position,
        map: this.map
      });
      this.polygonVertexMarkers.push({
        marker: marker
      });
    },
    clearPolygonVertexMarkers: function clearPolygonVertexMarkers() {
      this.polygonVertexMarkers.forEach(function (item) {
        item.marker.setMap(null);
      });
      this.polygonVertexMarkers = [];
    },
    updatePolygonData: function updatePolygonData(polygon) {
      this.clearPolygonVertexMarkers();
      var path = polygon.getPath();
      var markers = [];
      for (var i = 0; i < path.getLength(); i++) {
        var point = path.getAt(i);
        markers.push({
          lat: point.getLat(),
          lng: point.getLng()
        });
        this.addVertexMarker(point, i + 1);
      }
      var area = 0;
      if (markers.length >= 3) {
        area = this.calculatePolygonArea(markers);
      }
      this.$emit('draw-data-change', {
        markers: markers,
        area: area,
        circle: null
      });
    },
    calculatePolygonArea: function calculatePolygonArea(markers) {
      if (markers.length < 3) return 0;
      var area = 0;
      var n = markers.length;
      for (var i = 0; i < n; i++) {
        var j = (i + 1) % n;
        area += markers[i].lng * markers[j].lat;
        area -= markers[j].lng * markers[i].lat;
      }
      area = Math.abs(area) / 2;
      var avgLat = markers.reduce(function (sum, m) {
        return sum + m.lat;
      }, 0) / n;
      var metersPerDegreeLat = 111320;
      var metersPerDegreeLng = 111320 * Math.cos(avgLat * Math.PI / 180);
      area = area * metersPerDegreeLat * metersPerDegreeLng / 1000000;
      return area;
    },
    loadExistingData: function loadExistingData() {
      var _this5 = this;
      // 保存初始数据用于撤销功能
      this.saveInitialData();
      if (this.circle && this.circle.center && this.circle.radius) {
        var center = new window.qq.maps.LatLng(parseFloat(this.circle.center.lat), parseFloat(this.circle.center.lng));
        var radius = parseFloat(this.circle.radius);
        this.circleOverlay = new window.qq.maps.Circle({
          center: center,
          radius: radius,
          fillColor: new window.qq.maps.Color(64, 158, 255, 0.3),
          strokeColor: new window.qq.maps.Color(64, 158, 255, 1),
          strokeWeight: 2,
          editable: true,
          map: this.map
        });
        window.qq.maps.event.addListener(this.circleOverlay, 'radius_changed', function () {
          var newRadius = _this5.circleOverlay.getRadius();
          var newArea = Math.PI * newRadius * newRadius / 1000000;
          _this5.$emit('draw-data-change', {
            markers: [],
            area: newArea,
            circle: {
              center: {
                lat: center.getLat(),
                lng: center.getLng()
              },
              radius: newRadius
            }
          });
        });
      } else if (this.markers && this.markers.length > 0) {
        this.clearPolygonVertexMarkers();
        var path = [];
        this.markers.forEach(function (marker, index) {
          var point = new window.qq.maps.LatLng(marker.lat, marker.lng);
          path.push(point);
          _this5.addVertexMarker(point, index + 1);
        });
        this.polygon = new window.qq.maps.Polygon({
          path: path,
          fillColor: new window.qq.maps.Color(64, 158, 255, 0.3),
          strokeColor: new window.qq.maps.Color(64, 158, 255, 1),
          strokeWeight: 2,
          editable: true,
          map: this.map
        });

        // 为加载的现有多边形添加事件监听
        window.qq.maps.event.addListener(this.polygon.getPath(), 'insert_at', function () {
          _this5.updatePolygonData(_this5.polygon);
        });
        window.qq.maps.event.addListener(this.polygon.getPath(), 'remove_at', function () {
          _this5.updatePolygonData(_this5.polygon);
        });
        window.qq.maps.event.addListener(this.polygon.getPath(), 'set_at', function () {
          _this5.updatePolygonData(_this5.polygon);
        });
        window.qq.maps.event.addListener(this.polygon, 'mouseup', function () {
          _this5.updatePolygonData(_this5.polygon);
        });
        window.qq.maps.event.addListener(this.polygon, 'path_changed', function () {
          _this5.updatePolygonData(_this5.polygon);
        });
      }
    },
    saveInitialData: function saveInitialData() {
      // 深拷贝保存初始数据
      this.initialData = {
        markers: JSON.parse(JSON.stringify(this.markers || [])),
        circle: this.circle ? JSON.parse(JSON.stringify(this.circle)) : null,
        area: this.area || 0
      };
    },
    restoreInitialArea: function restoreInitialArea() {
      var _this6 = this;
      // 撤销到初始配送范围
      this.clearAllDrawings();

      // 恢复初始数据
      if (this.initialData.circle && this.initialData.circle.center && this.initialData.circle.radius) {
        var center = new window.qq.maps.LatLng(parseFloat(this.initialData.circle.center.lat), parseFloat(this.initialData.circle.center.lng));
        var radius = parseFloat(this.initialData.circle.radius);
        this.circleOverlay = new window.qq.maps.Circle({
          center: center,
          radius: radius,
          fillColor: new window.qq.maps.Color(64, 158, 255, 0.3),
          strokeColor: new window.qq.maps.Color(64, 158, 255, 1),
          strokeWeight: 2,
          editable: true,
          map: this.map
        });
        this.disableCircleCenterEdit(this.circleOverlay);
        var area = Math.PI * radius * radius / 1000000;
        this.$emit('draw-data-change', {
          markers: [],
          area: area,
          circle: this.initialData.circle
        });
        window.qq.maps.event.addListener(this.circleOverlay, 'radius_changed', function () {
          var newRadius = _this6.circleOverlay.getRadius();
          var newArea = Math.PI * newRadius * newRadius / 1000000;
          _this6.$emit('draw-data-change', {
            markers: [],
            area: newArea,
            circle: {
              center: {
                lat: center.getLat(),
                lng: center.getLng()
              },
              radius: newRadius
            }
          });
        });
      } else if (this.initialData.markers && this.initialData.markers.length > 0) {
        this.clearPolygonVertexMarkers();
        var path = [];
        this.initialData.markers.forEach(function (marker, index) {
          var point = new window.qq.maps.LatLng(marker.lat, marker.lng);
          path.push(point);
          _this6.addVertexMarker(point, index + 1);
        });
        this.polygon = new window.qq.maps.Polygon({
          path: path,
          fillColor: new window.qq.maps.Color(64, 158, 255, 0.3),
          strokeColor: new window.qq.maps.Color(64, 158, 255, 1),
          strokeWeight: 2,
          editable: true,
          map: this.map
        });

        // 添加事件监听
        window.qq.maps.event.addListener(this.polygon.getPath(), 'insert_at', function () {
          _this6.updatePolygonData(_this6.polygon);
        });
        window.qq.maps.event.addListener(this.polygon.getPath(), 'remove_at', function () {
          _this6.updatePolygonData(_this6.polygon);
        });
        window.qq.maps.event.addListener(this.polygon.getPath(), 'set_at', function () {
          _this6.updatePolygonData(_this6.polygon);
        });
        window.qq.maps.event.addListener(this.polygon, 'mouseup', function () {
          _this6.updatePolygonData(_this6.polygon);
        });
        window.qq.maps.event.addListener(this.polygon, 'path_changed', function () {
          _this6.updatePolygonData(_this6.polygon);
        });
        this.$emit('draw-data-change', {
          markers: this.initialData.markers,
          area: this.initialData.area,
          circle: null
        });
      }
      this.$message && this.$message.success('已撤销到初始配送范围');
    },
    clearAllDrawings: function clearAllDrawings() {
      // 清空所有绘制内容
      if (this.circleOverlay) {
        this.circleOverlay.setMap(null);
        this.circleOverlay = null;
      }
      if (this.polygon) {
        this.polygon.setMap(null);
        this.polygon = null;
      }
      this.clearPolygonVertexMarkers();

      // 重置绘制模式
      if (this.drawingManager) {
        this.drawingManager.setDrawingMode(null);
      }

      // 通知父组件清空数据
      this.$emit('draw-data-change', {
        markers: [],
        area: 0,
        circle: null
      });
      this.$message && this.$message.success('已清空配送范围');
    },
    loadTencentMap: function loadTencentMap() {
      var _this7 = this;
      if (window.qq && window.qq.maps) {
        this.initMap();
        return;
      }
      var script = document.createElement('script');
      script.src = "https://map.qq.com/api/js?v=2.exp&key=J5IBZ-PQSKP-3VMDD-V4URW-5ZH3J-2RFPK&libraries=drawing&callback=initTencentMap";
      script.onerror = function () {
        console.error('腾讯地图加载失败');
      };
      document.head.appendChild(script);
      window.initTencentMap = function () {
        _this7.initMap();
      };
    }
  },
  mounted: function mounted() {
    var _this8 = this;
    this.$nextTick(function () {
      _this8.loadTencentMap();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.storeMarker) {
      this.storeMarker.setMap(null);
    }
    this.clearPolygonVertexMarkers();
    if (this.circleOverlay) {
      this.circleOverlay.setMap(null);
    }
    if (this.polygon) {
      this.polygon.setMap(null);
    }
    if (this.drawingManager) {
      this.drawingManager.setMap(null);
    }
  }
};